<div [hidden]="!featureLoaded">
    <div class="wizard-header">
        <div class="page-title">
            {{'contractModifications.wizard.title' | translate}}
        </div>
        <div class="d-flex justify-content-between flex-column flex-xl-row">
            <div class="l-summary-container" *ngIf="
                currentWizardStep !== wizardStepsEnum.ContractModification_ChooseContractAndModificationType && 
                currentWizardStep !== wizardStepsEnum.ContractModification_Preview && 
                currentWizardStep !== wizardStepsEnum.ContractModification_RequestSent">
                <span *ngIf="contractModificationRequestHeader?.contractName">
                    {{'contractModifications.wizard.contract' | translate}} 
                    <span class="text-primary fw-bold">{{contractModificationRequestHeader?.contractName}}</span>
                </span>
                <span *ngIf="contractModificationRequestHeader?.outstandingAmount && 
                    contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.REIMBURSEMENT?.id">
                    @switch (dictionaryContractType.code) {
                        @case (ContractType.OPERATIONAL_LEASING) {
                            {{('outstandingAmount.operationalLeasing' | translate)}}
                        }
                        @case (ContractType.FINANCIAL_LEASING) {
                            {{('outstandingAmount.financialLeasing' | translate)}}
                        }
                        @case (ContractType.CREDIT) {
                            {{('outstandingAmount.credit' | translate)}}
                        }
                    }
                    <span class="text-primary fw-bold">{{contractModificationRequestHeader?.outstandingAmount | number:"0.1"}} {{contractModificationRequestHeader?.currencyCode}}</span>
                </span>

                <span *ngIf="contractModificationRequestHeader?.outstandingAmount && contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id">
                    {{'contractModifications.wizard.contractEndDate' | translate}} 
                    <span class="text-primary fw-bold">{{contractModificationRequestHeader?.contractEndDate | localizedDate}}</span>
                </span>
            </div>

            <div class="l-summary-container align-items-xl-end" *ngIf="currentWizardStep !== wizardStepsEnum.ContractModification_ChooseContractAndModificationType  && currentWizardStep !== wizardStepsEnum.ContractModification_Preview">
                <span *ngIf="contractModificationRequestHeader?.installmentAmount && contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id">
                    {{'contractModifications.wizard.installmentAmount' | translate}} 
                    <span class="text-primary fw-bold">
                        {{contractModificationRequestHeader?.installmentAmount | number:"0.1"}} {{contractModificationRequestHeader?.currencyCode}}
                    </span>
                </span>

                <span *ngIf="contractModificationRequestHeader?.invoicesAmount && contractModificationRequest.dictionaryModificationTypeId === DICTIONARY_CONTRACT_MODIFICATION_TYPE.INSTALLMENT_DEFERRAL?.id">
                    {{'contractModifications.wizard.invoicesAmount' | translate}} 
                    <span class="text-primary fw-bold">
                        {{contractModificationRequestHeader?.invoicesAmount | number:"0.1"}} {{contractModificationRequestHeader?.currencyCode}}
                    </span>
                </span>
            </div>
        </div>
    </div>

    <div class="wizard-container">
        <button *ngIf="currentWizardStep !== wizardStepsEnum.ContractModification_RequestSent" 
            class="btn link-btn btn-back-txt" (click)="previousStepHandler(currentWizardStep)"
        >
            <i class="app-icon icon icon-arrow-left icon-xl me-2"></i>
            <span>
                {{ (currentWizardStep === wizardStepsEnum.ContractModification_ChooseContractAndModificationType ? 'contractModifications.wizard.navContractModificationsRequestList' : 'contractModifications.wizard.backBtnLabel') | translate }}
            </span>
        </button>

        <div class="wizard-main-content" [ngSwitch]="currentWizardStep">
            <ng-container *ngSwitchCase="wizardStepsEnum.ContractModification_ChooseContractAndModificationType">
                <contract-modification-type
                    [contractModificationRequest]="contractModificationRequest"
                    [DICTIONARY_CONTRACT_MODIFICATION_TYPE]="DICTIONARY_CONTRACT_MODIFICATION_TYPE"
                    [contractsDataSource]="contractsDataSource"
                    [contractModificationRequestType]="contractModificationRequestType"
                    [reimbursementTypeDatasource]="reimbursementTypeDatasource"
                    [modificationTypeDisabled]="!isContractSelected"

                    [contractSelectHandler]="contractSelectHandler"
                    [contractModificationRequestTypeChangeHandler]="contractModificationRequestTypeChangeHandler"
                    [contractModificationReimbursementTypeChangeHandler]="contractModificationReimbursementTypeChangeHandler"
                    [nextStepHandler]="nextStepHandler"
                    [deleteFileHandler]="_fileHandler.deleteFileHandler"
                    [uploadFilesHandler]="_fileHandler.uploadFilesHandler"
                    >
                </contract-modification-type>
            </ng-container>

            <ng-container *ngSwitchCase="wizardStepsEnum.ContractModification_Why">
                <contract-modification-reason
                    [contractModificationRequest]="contractModificationRequest"
                    [DICTIONARY_CONTRACT_MODIFICATION_TYPE]="DICTIONARY_CONTRACT_MODIFICATION_TYPE"
                    [DICTIONARY_REIMBURSEMENT_TYPE]="DICTIONARY_REIMBURSEMENT_TYPE"
                    [contractModificationRequestReasonDatasource]="contractModificationRequestReasonDatasource"
                    [firstQuestionFormGroup]="firstQuestionFormGroup"

                    [nextStepHandler]="nextStepHandler"
                    [deleteFileHandler]="_fileHandler.deleteFileHandler"
                    [uploadFilesHandler]="_fileHandler.uploadFilesHandler"
                >
                </contract-modification-reason>
            </ng-container>

            <ng-container *ngSwitchCase="wizardStepsEnum.ContractModification_PaymentSource">
                <contract-modification-payment-source
                    [contractModificationRequest]="contractModificationRequest"
                    [paymentSourcesDatasource]="paymentSourcesDatasource"
                    [secondQuestionFormGroup]="secondQuestionFormGroup"

                    [nextStepHandler]="nextStepHandler"
                    [deleteFileHandler]="_fileHandler.deleteFileHandler"
                    [uploadFilesHandler]="_fileHandler.uploadFilesHandler"
                >
                </contract-modification-payment-source>
            </ng-container>

            <ng-container *ngSwitchCase="wizardStepsEnum.ContractModification_AmountPayInAdvance">
                <contract-modification-payment-amount
                    [contractModificationRequest]="contractModificationRequest"
                    [contractModificationRequestHeader]="contractModificationRequestHeader"
                    [thirdQuestionFormGroup]="thirdQuestionFormGroup"

                    [nextStepHandler]="nextStepHandler"
                >
                </contract-modification-payment-amount>
            </ng-container>

            <ng-container *ngSwitchCase="wizardStepsEnum.ContractModification_RequestPurpose">
                <contract-modification-purpose
                    [contractModificationRequest]="contractModificationRequest"
                    [DICTIONARY_CONTRACT_MODIFICATION_TYPE]="DICTIONARY_CONTRACT_MODIFICATION_TYPE"
                    [DICTIONARY_REIMBURSEMENT_TYPE]="DICTIONARY_REIMBURSEMENT_TYPE"
                    [contractModificationPurposeDatasource]="contractModificationPurposeDatasource"
                    [fourthQuestionFormGroup]="fourthQuestionFormGroup"

                    [nextStepHandler]="nextStepHandler"
                >
                </contract-modification-purpose>
            </ng-container>

            <ng-container *ngSwitchCase="wizardStepsEnum.ContractModification_PostponePeriod">
                <contract-modification-postpone-period
                    [postponedPeriodRange]="postponedPeriodRange"
                    (postponedPeriodRangeChanged)="mapPostponedPeriod($event)"

                    [nextStepHandler]="nextStepHandler"
                >
                </contract-modification-postpone-period>
            </ng-container>

            <ng-container *ngSwitchCase="wizardStepsEnum.ContractModification_Preview">
                <contract-modification-preview
                    [contractModificationRequest]="contractModificationRequest"
                    [contractModificationRequestHeader]="contractModificationRequestHeader"
                    [DICTIONARY_CONTRACT_MODIFICATION_TYPE]="DICTIONARY_CONTRACT_MODIFICATION_TYPE"
                    [DICTIONARY_REIMBURSEMENT_TYPE]="DICTIONARY_REIMBURSEMENT_TYPE"
                    [reasonOfRequest]="reasonOfRequest"
                    [purposeOfRequest]="purposeOfRequest"
                    [description]="description"
                    [otherModificationType]="otherModificationType"
                    [editWizardStepHandler]="editWizardStepHandler"
                    [nextStepHandler]="nextStepHandler"
                    [deleteFileHandler]="_fileHandler.deleteFileHandler"
                    [uploadFilesHandler]="_fileHandler.uploadFilesHandler"
                >
                </contract-modification-preview>
            </ng-container>

            <ng-container *ngSwitchCase="wizardStepsEnum.ContractModification_RequestSent">
                <contract-modification-request-sent [navigateToListHandler]="redirectContractModificationRequestsHandler">
                </contract-modification-request-sent>
            </ng-container>
        </div>
    </div>
</div>
